/**
 * FloatingThemeToggle — Track C (locked decision A4).
 *
 * Fixed-position wrapper around the shared `<ThemeToggle>` used on
 * the 5 "naked" surfaces that mount no shell chrome:
 *   /partner/service-area
 *   /partner/pricing-wizard
 *   /partner/tier-upgrade
 *   /gift/buy
 *   /gift/redeem
 *
 * This is a POSITIONING wrapper, NOT a fork of the toggle. All theme
 * state / accessibility / cycle logic lives in `<ThemeToggle>`; this
 * component only pins it to `top: 12; right: 12; z-index: 40` so
 * the toggle stays reachable across every naked page without
 * intruding on the page's primary CTA.
 *
 * Variant: passes `variant="compact"` so the inner toggle renders
 * icons-only (no text labels) — floating real-estate is tight and
 * the space budget for a labeled variant on top of the form's
 * primary CTA is prohibitive. Compact variant surfaces a native
 * `title` tooltip per segment ("Use light theme" / "Match my device
 * setting" / "Use dark theme") for hover disambiguation.
 *
 * The 3 redirect-handoff surfaces (`/auth/google`,
 * `/provider/connect/return`, `/partner/onboarding`) deliberately
 * do NOT use this wrapper — those pages inherit `data-theme` from
 * the pre-first-paint boot script but have no interactive toggle
 * (option A4 hybrid).
 */
import React from "react";
import ThemeToggle from "@/components/ThemeToggle";

export default function FloatingThemeToggle({ size }) {
  return (
    <div
      className="fixed top-3 right-3 z-40"
      data-testid="floating-theme-toggle"
    >
      <ThemeToggle size={size} variant="compact" />
    </div>
  );
}
